const translate = (rus, uzb) => {
    return localStorage.getItem('language') === 'ru' ? rus : uzb
}

export default translate